export default __webpack_public_path__ + "static/media/gallery_09.d2ef760d.jpg";